import { createI18n } from 'vue-i18n';
import { env } from '@/config/env';
import { resolveAppLocale } from '@/config/localeSupport';

const localeLoaders = {
    cn: () => import(/* webpackChunkName: "locale-cn" */ './locales/cn.json'),
    en: () => import(/* webpackChunkName: "locale-en" */ './locales/en.json'),
    es: () => import(/* webpackChunkName: "locale-es" */ './locales/es.json'),
    ko: () => import(/* webpackChunkName: "locale-ko" */ './locales/ko.json'),
    ma: () => import(/* webpackChunkName: "locale-ma" */ './locales/ma.json'),
    pt: () => import(/* webpackChunkName: "locale-pt" */ './locales/pt.json'),
    ru: () => import(/* webpackChunkName: "locale-ru" */ './locales/ru.json'),
    vn: () => import(/* webpackChunkName: "locale-vn" */ './locales/vn.json'),
    ja: () => import(/* webpackChunkName: "locale-ja" */ './locales/ja.json'),
    de: () => import(/* webpackChunkName: "locale-de" */ './locales/de.json'),
    fr: () => import(/* webpackChunkName: "locale-fr" */ './locales/fr.json'),
    th: () => import(/* webpackChunkName: "locale-th" */ './locales/th.json'),
    uk: () => import(/* webpackChunkName: "locale-uk" */ './locales/uk.json'),
    'zh-tw': () => import(/* webpackChunkName: "locale-zh-tw" */ './locales/zh-tw.json'),
};

const loadedLocales = new Set();

const i18n = createI18n({
    locale: resolveAppLocale(),
    fallbackLocale: env.I18N_FALLBACK_LOCALE,
    messages: {},
});

function getLocaleMessage(module) {
    return module.default || module;
}

function setI18nLanguage(locale) {
    if (i18n.global.locale && typeof i18n.global.locale === 'object') {
        i18n.global.locale.value = locale;
    } else {
        i18n.global.locale = locale;
    }
}

export async function loadLocaleMessages(locale) {
    const loader = localeLoaders[locale] || localeLoaders[env.I18N_FALLBACK_LOCALE] || localeLoaders.en;
    const resolvedLocale = localeLoaders[locale] ? locale : (env.I18N_FALLBACK_LOCALE || 'en');

    if (!loadedLocales.has(resolvedLocale)) {
        const messages = getLocaleMessage(await loader());
        i18n.global.setLocaleMessage(resolvedLocale, messages);
        loadedLocales.add(resolvedLocale);
    }

    return resolvedLocale;
}

export async function setupI18nMessages(locale = resolveAppLocale()) {
    const fallbackLocale = env.I18N_FALLBACK_LOCALE || 'en';
    await Promise.all([
        loadLocaleMessages(locale),
        fallbackLocale === locale ? Promise.resolve() : loadLocaleMessages(fallbackLocale),
    ]);
    setI18nLanguage(locale);
    return i18n;
}

export default i18n;
